module.exports = __webpack_public_path__ + "static/media/background-7.7c37cc9c.jpg";